import { KeyValue } from '@/main/models/common';
import {
  AnnouncementActionTypes,
  AnnouncementTypes
} from './announcementTypes';
import { CompanyAnnouncerFilterRequest } from '@/main/models/request/announcementRequest';

export function getDomainAnnouncements(
  guidCompany?: string
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.GET_DOMAIN_ANNOUNCEMENTS,
    payload: { guidCompany }
  };
}

export function saveDomainAnnouncements(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.SAVE_DOMAIN_ANNOUNCEMENTS,
    payload: { data, isError, errorMessages }
  };
}

export function getStatusDomain(
  showExpired?: boolean
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.GET_STATUS_DOMAIN,
    payload: { showExpired }
  };
}

export function saveStatusDomain(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.SAVE_STATUS_DOMAIN,
    payload: { data, isError, errorMessages }
  };
}

export function getDomainCompanyAnnouncers(
  request: CompanyAnnouncerFilterRequest
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.GET_DOMAIN_COMPANY_ANNOUNCERS,
    payload: { request }
  };
}

export function saveDomainCompanyAnnouncers(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.SAVE_DOMAIN_COMPANY_ANNOUNCERS,
    payload: { data, isError, errorMessages }
  };
}

export function getDomainWhoCanSee(): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.GET_DOMAIN_WHO_CAN_SEE
  };
}

export function saveDomainWhoCanSee(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AnnouncementActionTypes {
  return {
    type: AnnouncementTypes.SAVE_DOMAIN_WHO_CAN_SEE,
    payload: { data, isError, errorMessages }
  };
}
